<template>
<div id="table">
  <!-- マトリクス設定モーダル -->
  <dd-matrix-conf-modal
    ref="matrixConfModalRef"
    @getTableInfoAndAllData="getTableInfoAndAllData"
  />
  <!-- 登録・編集モーダル -->
  <div v-if="showModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" >
          <div class="modal-container">
            <div class="modal-header">
              {{ tableModel.tableName }}の<span v-if="isNew">新規登録</span><span v-else-if="isDelete">削除</span><span v-else>編集</span>
            </div>
            <div v-if="validateErrorMessages.CustomConstraint" class="error_message">
              {{ validateErrorMessages.CustomConstraint }}
            </div>
            <div class="modal-body">
              <!-- カラム名 -->
              <div class="edit-table">
                <div class="edit-th" v-if="!isNew || isDelete || isEditable(index)" v-for="(col, index) in tableModel.columnList" :key="index">
                  {{ col.columnName }}
                </div>
              </div>
              <!-- 入力欄 -->
              <div class="edit-table" v-for="(data, index) in columnData" :key="index">
                <div v-if="(!isNew && !isEditable(index)) || isDelete">{{ data }}</div>
                <input v-else-if="isEditable(index)" v-model="columnData[index]" :type="inputType(index)">
              </div>
            </div>
            <div class="modal-footer">
              <button class="main_btn register_btn" v-if="isNew" @click="submit">登録</button>
              <button class="main_btn delete_btn" v-else-if="isDelete" @click="confirmDelete">削除</button>
              <button class="main_btn" v-else @click="submit">変更</button>
              <button class="main_btn close-btn" @click="showModal = false">閉じる</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
  <!-- ボタン・アップロード・ページャ -->
  <div v-if="tableModel.tableName" class="title_area">
    <h3>{{ tableModel.tableName }}テーブル</h3>
    <button class="main_btn register_btn" @click="openNewModal">新規登録</button>
    <button @click="downLoadCsv" class="main_btn" v-if="tableModel.columnDataList && tableModel.columnDataList.length > 0">CSV出力</button>
    <div class="upload_wrapper">
      <input ref="fileInput" type="file" multiple="multiple" @change="onChange" />
      <button @click="uploadFile" class="main_btn">アップロード</button>
    </div>
     <!-- ページ -->
     <dd-pager
       v-if="tableModel.columnDataList && tableModel.columnDataList.length > 0"
       :pageNo="pageNo"
       :dataCountPerPage= dataCount
       :totalDataCount= totalCount
       @callback = paging
     />
  </div>

  <!-- データテーブル -->
  <div class="table_wrapper" v-if="tableModel.columnDataList && tableModel.columnDataList.length > 0">
    <table>
      <thead>
        <tr>
          <th v-for="(column, index) in tableModel.columnList" :key="index">{{ column.columnName }}</th>
          <th v-if="tableModel.tableName" class="func_th">機能</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rowData, index) in tableModel.columnDataList" :key ="index">
          <td v-for="(colData, index) in rowData" :key ="index">{{ colData }}</td>
          <td>
            <button class="main_btn" @click="openEditModal(rowData)">編集</button>
            <button class="main_btn delete_btn" @click="openDeleteModal(rowData)">削除</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
</template>
<script>
import axios from 'axios'
import encoding from 'encoding-japanese'
import {API_URL, COLUMN_NAME} from '../../constants/App'
import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import Pager from '../../components/common/Pager'
import MatrixConfModal from '../../components/master/MatrixConfModal'

export default {
  name: 'dd-table',
  components: {
    'dd-pager': Pager,
    'dd-matrix-conf-modal': MatrixConfModal
  },
  props: {
    tableModel: Object,
    totalCount: Number,
    pageNo: Number,
    dataCount: Number,
    changeTbl: Boolean
  },
  data () {
    return {
      // データ
      columnData: [],
      files: [],
      showModal: false,
      isNew: false,
      isDelete: false,
      errorMessage: {text: ''},
      validateErrorMessages: {CustomConstraint: ''}
    }
  },
  methods: {
    getTableInfoAndAllData: function () {
      this.$emit('getTableInfoAndAllData', this.tableModel.tableName, this.pageNo, this.dataCount)
    },
    openNewModal: function () {
      if (this.tableModel.tableName === 'm_matrix') {
        this.$refs.matrixConfModalRef.showNewModal()
        this.isNew = false
        this.isDelete = false
        this.clearMessages()
        this.showModal = false
      } else {
        this.isNew = true
        this.isDelete = false
        this.columnData = Array(this.tableModel.columnList.length)
        this.clearMessages()
        this.showModal = true
      }
    },
    openEditModal: function (rowData) {
      if (this.tableModel.tableName === 'm_matrix') {
        this.$refs.matrixConfModalRef.showEditModal(rowData)
        this.isNew = false
        this.isDelete = false
        this.columnData = Object.assign([], rowData)
        this.clearMessages()
        this.showModal = false
      } else {
        this.isNew = false
        this.isDelete = false
        this.columnData = Object.assign([], rowData)
        this.clearMessages()
        this.showModal = true
      }
    },
    openDeleteModal: function (rowData) {
      this.isNew = false
      this.isDelete = true
      this.columnData = rowData
      this.clearMessages()
      this.showModal = true
    },
    isEditable: function (colIdx) {
      let col = this.tableModel.columnList[colIdx]
      return !col.columnKey && col.columnName !== COLUMN_NAME.CORP_ID
    },
    inputType: function (colIdx) {
      return 'text'
    },
    submit: function () {
      this.clearMessages()
      let payload = {
        columModelList: this.tableModel.columnList,
        tableDataList: this.columnData,
        isNew: this.isNew
      }
      axios.post(API_URL.MASTER, payload)
        .then(response => {
          this.showModal = false
          let modalData = {
            messages: this.isNew ? ['登録しました。'] : ['変更しました。'],
            onOk: () => {
              this.$emit('getTableInfoAndAllData', this.tableModel.tableName, this.pageNo, this.dataCount)
            }
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    confirmDelete: function () {
      let modalData = {
        messages: ['本当に削除しますか？'],
        modalType: 'confirm',
        textAlign: 'left',
        onOk: this.deleteSubmit
      }
      App.showModal(modalData)
    },
    deleteSubmit: function () {
      let payload = {
        columModelList: this.tableModel.columnList,
        tableDataList: this.columnData,
        isNew: false
      }
      axios.post(API_URL.MASTER + '/delete', payload)
        .then(response => {
          this.showModal = false
          let modalData = {
            messages: ['削除しました。'],
            onOk: () => {
              this.$emit('getTableInfoAndAllData', this.tableModel.tableName, this.pageNo, this.dataCount)
            }
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    downLoadCsv: function () {
      let param = this.tableModel.tableName
      axios.get(API_URL.MASTER + '/download/' + param)
        .then(response => {
          var arrayData = response.data.data.columnDataList
          var csvData = arrayData.map(function (l) { return l.join(',') }).join('\r\n')
          let sjisArray = encoding.convert(encoding.stringToCode(csvData), {to: 'SJIS'})
          let blob = new Blob([new Uint8Array(sjisArray)], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.tableModel.tableName + '.csv'
          link.click()
          let modalData = {
            messages: ['ファイルをダウンロードしました。']
          }
          App.showModal(modalData)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    onChange: function () {
      event.preventDefault()
      this.files = event.target.files
    },
    uploadFile: function () {
      event.preventDefault()
      if (!this.files.length) {
        App.showModal({
          messages: ['ファイルを選択してください。']
        })
        return
      }
      let payload = new FormData()
      for (let i = 0; i < this.files.length; i++) {
        payload.append('files', this.files[i])
      }
      let columnList = this.tableModel.columnList
      for (var i = 0; i < columnList.length; i++) {
        payload.append('columnModelList', JSON.stringify(columnList[i]))
      }
      axios.post(API_URL.UPLOAD + '/csv/master', payload
      ).then(response => {
        this.message = response.data.infoMessage
        let modalData = {
          messages: ['アップロードが完了しました。'],
          onOk: () => {
            this.$emit('getTableInfoAndAllData', this.tableModel.tableName, this.pageNo, this.dataCount)
          }
        }
        App.showModal(modalData)
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      })
    },
    clearMessages: function () {
      this.errorMessage = {text: ''}
      this.validateErrorMessages = {CustomConstraint: ''}
    },
    // 数字ボタンが押すたびに動く処理
    paging: function (currentPageNo) {
      this.$emit('getTableInfoAndAllData', this.tableModel.tableName, currentPageNo, this.dataCount)
    }
  }
}
</script>
<style lang="scss" scoped>
#table {
  height: 100%;
}
input {
  line-height: 26px;
  border-radius: 0px;
  width: 87%;
  margin: 0;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.edit-tab{
  display:none;
}
.modal-table, .edit-table {
  float: left;
  display: block;
  width: 50%;
}
.modal-table div, .edit-table div {
  display: block;
  border: 1px solid #ddd;
  border-radius: 0px;
  min-height: 26px;
  line-height: 26px;
  padding: .375rem .75rem;
  overflow: hidden;
  white-space: nowrap;
}
.modal-th, .edit-th {
  background: #666;
  color: #FFF;
  opacity: 0.9;
}
.title_area {
  padding: 10px 0;
  h3 {
    font-size: 1.5em;
    display: inline-block;
  }
  .upload_wrapper {
    margin-top: 30px;
    input[type="file"] {
      max-width: calc(100% - 151px);
      cursor: pointer;
    }
  }
}
table {
  vertical-align: middle;
  table-layout: unset;
  th {
    background: #666;
    color: #FFF;
    width: auto;
  }
  td {
    width: auto;
    white-space: nowrap;
  }
}
.table_wrapper {
  overflow: auto;
  .main_btn {
    line-height: 22px;
    margin: 0 5px;
  }
  th.func_th {
    width: 106px;
  }
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  display: table;
  transition: opacity .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  width: 400px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .1);
  max-height: 80%;
  overflow: auto;
}
.modal-header {
  border-bottom: 2px solid #ddd;
  padding-bottom: 10px;
  font-weight: bold;
}
.modal-body {
  font-size: 12px;
  margin: 10px 0 20px;
  overflow-y: auto;
  overflow-x: hidden;
}
.modal-footer{
  text-align: center;
}
.modal-enter {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.error_message {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/master/Table.vue